const BASE_API = process.env.REACT_APP_BASE_URL;

export async function fetchSubscriptionStatus(accessToken) {
  const url = new URL(BASE_API)
  url.pathname = "/api/v1/email_subscriptions"
  url.searchParams.set('token', accessToken)

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      }
    });

    if (!response.ok) {
      const { message } = await response.json();
      throw new Error(message);
    }

    const data = await response.json();
    return data.data;
  } catch (error) {
    throw error;
  }
}


export async function updateSubscriptionStatus(accessToken, status) {
  const url = new URL(BASE_API)
  url.pathname = "/api/v1/email_subscriptions"
  url.searchParams.set('token', accessToken)

  try {
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ subscribe: status, token: accessToken }),
    });

    if (!response.ok) {
      const { message } = await response.json();
      throw new Error(message);
    }

    const data = await response.json();
    return data.data;
  } catch (error) {
    throw error;
  }
}
